export default __webpack_public_path__ + "static/media/solving.18b3cb81.png";